import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';

import { useDonorCommentsColDefs } from '../utils/columnDefs';

type Props = {
  mode?: string;
  rowData: any[] | null;
};

export const DonorScheduleGrid = ({ mode, rowData }: Props) => {
  const defaultGridOptions = useDefaultGridOptions();
  const donorCommentsColDefs = useDonorCommentsColDefs();
  return (
    <div className="aspiration__donor-schedule-grid">
      <WithLocalStorage storageKey="aspiration__donor-schedule-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${mode === 'dark' ? '-dark' : ''}`}
          rowData={rowData || null}
          defaultColDef={defaultColDef}
          columnDefs={donorCommentsColDefs}
          rowSelection="single"
          getRowId={(params) => params.data.donorCondition}
        />
      </WithLocalStorage>
    </div>
  );
};
